import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=bdf49106&scoped=true"
import script from "./LandingView.js?vue&type=script&lang=js&external"
export * from "./LandingView.js?vue&type=script&lang=js&external"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=bdf49106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf49106",
  null
  
)

export default component.exports